import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  NOTIFICATION_DROPDOWN_REFRESH,
} from "./actionTypes"

import {
  notificationDropdownRefreshSuccess,
  notificationDropdownRefreshError,
} from "./actions"

import {
  apiGetNotificationDropdownRefresh,
} from "../../../api/calls/notificationDropdown"

function* notificationDropdownRefresh({payload: data}) {
  try {
    const response = yield call(apiGetNotificationDropdownRefresh, data)
    yield put(notificationDropdownRefreshSuccess(response))
  } catch (error) {
    yield put(notificationDropdownRefreshError(error))
  }
}

export function* watchNotificationDropdownRefresh() {
  yield takeEvery(NOTIFICATION_DROPDOWN_REFRESH, notificationDropdownRefresh);
}

function* notificationDropdownSaga() {
  yield all([
    fork(watchNotificationDropdownRefresh),
  ]);
}

export default notificationDropdownSaga
